'use client';

import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface HowItWorksButtonProps {
  onClick: () => void;
}

export const HowItWorksButton = ({ onClick }: HowItWorksButtonProps) => {
  const { t } = useT();
  return (
    <Box
      onClick={onClick}
      sx={{
        display: { xs: 'none', sm: 'flex' },
        alignItems: 'center',
        gap: 0.5,
        px: 1.5,
        py: 0.5,
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
          bgcolor: 'action.hover',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 20,
          height: 20,
          borderRadius: '50%',
          bgcolor: '#2563eb',
          color: '#ffffff',
        }}
      >
        <Typography sx={{ fontSize: '0.75rem', fontWeight: 700 }}>i</Typography>
      </Box>
      <Typography
        sx={{
          fontSize: '0.9375rem',
          fontWeight: 500,
          color: 'text.primary',
        }}
      >
        {t('howItWorks.buttonLabel')}
      </Typography>
    </Box>
  );
};
